import styled from 'styled-components';
import {
  PerspectivesConditionalFormatting,
  ConditionalFormattingProps,
} from '@ardoq/perspectives';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { Island, ModalBodyLayout } from '@ardoq/page-layout';
import { Box } from '@ardoq/layout';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { t, type I18nLocale } from '@ardoq/i18n';

const ConditionalFormattingIsland = styled(Island)`
  overflow: hidden;
`;

type FormattingContentProps = {
  closeViewpointBuilder: () => void;
  state: ConditionalFormattingProps;
  primaryButtonConfig: PrimaryButtonConfig;
  i18nLocale: I18nLocale;
  // Commands are part of the state
};

export const ConditionalFormattingContent = ({
  state,
  closeViewpointBuilder,
  primaryButtonConfig,
  i18nLocale,
}: FormattingContentProps) => {
  return (
    <ModalBodyLayout
      footerContent={
        <ViewpointBuilderFooter
          closeViewpointBuilder={closeViewpointBuilder}
          primaryButtonConfig={primaryButtonConfig}
          i18nLocale={i18nLocale}
        />
      }
    >
      <Box padding="xlarge">
        <ConditionalFormattingIsland
          title={t(
            i18nLocale,
            'viewpointBuilder:conditionalFormatting.title',
            'Conditional formatting'
          )}
          subtitle={t(
            i18nLocale,
            'viewpointBuilder:conditionalFormatting.subtitle',
            'Make patterns and trends more apparent with automated color formatting based on rules you set here.'
          )}
          knowledgeBaseLink={KnowledgeBaseLink.CONDITIONAL_FORMATTING}
          minWidth="fit-content"
        >
          <PerspectivesConditionalFormatting
            {...state}
            isNewConditionalFormatting={true}
          />
        </ConditionalFormattingIsland>
      </Box>
    </ModalBodyLayout>
  );
};
